import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "./motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Core Infrastructure Matrix",
    body: "Standardized, liquid-cooled modular enclosures deployed as autonomous 10 MW tranches. Each unit operates as a sovereign power-and-compute cell — engineered, capitalized and cleared under institutional escrow structures before a single trench is cut.",
  },
  {
    n: "02",
    title: "Geopolitical Hardening",
    body: "Public utility grids, pipeline corridors and subsea cable networks now represent the weakest link in industrial data continuity. Equinox enclosures bypass compromised localized utilities entirely, removing single-jurisdiction exposure from the operational chain.",
  },
  {
    n: "03",
    title: "Zero-Fault Redundancy",
    body: "High-throughput tracking arrays maintain automated, instant failover data loops to international cloud infrastructure. When terrestrial conditions degrade, telemetry does not blink — the orbital layer absorbs the load without human intervention.",
  },
  {
    n: "04",
    title: "Tranche Specifications",
    body: "Each enclosure tranche ships as a self-contained 10 MW captive gas microgrid: liquid-cooled high-density compute halls, dedicated gas-turbine generation fully islanded from public utilities, dual-path orbital uplink arrays, and hardened perimeter security — delivered plug-and-play and remotely governed from the Equinox operations lattice.",
  },
];

export const Manifesto = () => {
  return (
    <section className="border-b border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
        <motion.p
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="text-[10px] tracking-[0.35em] uppercase text-zinc-500 mb-16"
        >
          01 / The Equinox Doctrine
        </motion.p>

        <div className="space-y-0">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              data-testid={`manifesto-chapter-${i + 1}`}
              variants={fadeUp}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={viewportOnce}
              className="group grid grid-cols-12 gap-6 border-t border-zinc-800 py-12 lg:py-16 hover:bg-[#101010] transition-colors duration-500"
            >
              <div className="col-span-12 sm:col-span-2">
                <span className="font-display text-5xl lg:text-7xl font-black text-outline group-hover:text-white group-hover:[-webkit-text-stroke:0px] transition-all duration-500">
                  {c.n}
                </span>
              </div>
              <div className="col-span-12 sm:col-span-4">
                <h3 className="font-display text-xl sm:text-2xl uppercase font-bold tracking-tight text-white">
                  {c.title}
                </h3>
              </div>
              <div className="col-span-12 sm:col-span-6">
                <p className="text-sm leading-relaxed text-zinc-400 max-w-xl">{c.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
